import moment from 'moment';

export const PROMOTION = {
    STAR_DATE: "2025-05-12 00:00:00",
    END_DATE: "2025-06-07 23:59:59",
    ICON: '🔥',
    TITLE: '',
    SUBTITLE: 'Aprovecha un 30% de descuento todo un año',
    PROMOTIONAL_CODE: 'HOTDAYS',
    URL_UTM: 'https://www.talisis.com/membresias?utm_campaign=Cybermonday&utm_source=banner',
    membership:{
        title:'Usa el código HOTDAYS y disfruta 🔥 30% de descuento 🔥 en cualquier membresía con',
        subtitle:'período anual.',
    }
};


const today = moment();
const endDate = moment(PROMOTION.END_DATE).add(1, 'days');

export const ACTIVATE_COUNTDOWN = moment().isSameOrAfter(moment(PROMOTION?.STAR_DATE, 'YYYY-MM-DD HH:mm:ss')) &&
    moment().isSameOrBefore(moment(PROMOTION?.END_DATE, 'YYYY-MM-DD HH:mm:ss'))
